export default {
    data: () => ({
        translations: {
            title: {
                el: "Όροι και Προϋποθέσεις Χρηστών Προγράμματος",
                en: "Terms of Use",
                it: "Termini e condizioni utente del programma"
            },
            info: {
                el: "Ανεβάστε τους όρους χρήσης της επιχείρησης (σε μορφή .pdf). Επιλέξτε το αρχείο pdf και, στη συνέχεια, πατήστε αποθήκευση.",
                en: `
                    Upload terms of use of business (in .pdf format). Select the pdf file
                    and then click save.
                `,
                it: "Scarica le condizioni d'uso del business (in formato .pdf). Seleziona il file pdf e poi clicca su salva."
            },
            termsOfUse: {
                el: "Οδηγίες Χρήσης",
                en: "Terms of Use:",
                it: "Istruzioni per l'uso"
            },
            validationError: {
                el: "Για να συνεχίσετε πρέπει να ανεβάσετε ένα νέο αρχείο",
                en: "To continue you must upload a new file",
                it: "Per continuare è necessario caricare un nuovo file"
            }
        }
    })
};
